import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output, ViewChildren, QueryList, ViewChild, AfterViewInit, AfterContentInit, OnChanges } from '@angular/core';
import { UISearchFieldModel, UIPropertyModel, UiSearchDefinitionService } from 'e5core-angular-services';
import { UiStyleService } from '../../services/ui-style.service';
import { E5coreUiSearchResultsBaseComponent } from './component/e5core-ui-search-results-base';
import { SearchDataSourceService } from '../../datasource/search-data-source.service';
import { E5coreUiSearchResultsMaterialComponent } from './component/e5core-ui-search-results-material.component';
import { DataSourceQuery } from '../../datasource/data-source-query';
import { SearchDataSourceOptions } from '../../datasource/search-data-source-options';

@Component({
  selector: 'e5core-ui-search-results',
  styleUrls: ['./../../css/default.css'], // (open)='onOpen' (link)='onLink'
  // We don't need a switch as the e5core-ui-datagrid handles the different implementations
  template: `
  <span *ngIf="!error">
    <e5core-ui-datagrid #SearchResults
      [datasource]='datasource'  [query]='query' [autoSearch]='autoSearch'
      (open)='onOpen($event)' (link)='onLink($event)'>
    </e5core-ui-datagrid>
  </span>
  <div *ngIf="error" class="e5core-component-error">{{error}}</div>`,
  //changeDetection: ChangeDetectionStrategy.OnPush
  providers: [
    SearchDataSourceService
  ]
})
export class E5coreUiSearchResultsComponent implements OnInit  {

  @Input() searchDefinitionId : number ;
  @Input() query: DataSourceQuery ;
  // @Input() set query(value: DataSourceQuery) {
  //   // If this is called before the children as resolved then store the value until they exist.
  //   if(this.search && this.resultChildren)
  //     this.search(value) ;
  //   else 
  //     this.lastQuery = value ;
  // };
  @Input() includeSla : boolean ;
  @Input() includeNextDueTask : boolean ;
  @Input() autoSearch: boolean ;
  @Output() open = new EventEmitter<any>() ;
  @Output() link = new EventEmitter<any>() ;

  @ViewChildren("SearchResults") resultChildren !: QueryList<E5coreUiSearchResultsBaseComponent>;

  error: string ;

  constructor(public style:UiStyleService, public datasource: SearchDataSourceService) { }

  ngOnInit() {
    if (this.searchDefinitionId == null) {
      this.error = 'e5core-ui-search-results [searchDefinitionId] must be specified' ;
      console.error(this.error);
      return ;
    }
    this.datasource.setSearchDefinitionId(this.searchDefinitionId) ;
    let options:SearchDataSourceOptions = this.datasource.defaultOptions() ;
    options.includeSla = this.includeSla ;
    options.includeNextDueTask = this.includeNextDueTask ;
    this.datasource.setDefaultOptions(options) ;
  }

  /**
   *  Pass the open work item event on to any listener.
   * @param data the row of data, including the "Id" from the table.
   */
  onOpen(data:any) {
    this.open.emit(data) ;
  }

  /**
   *  Pass the open link on to any listener.
   * @param data the row of data, including the "Id" from the table.
   */
  onLink(url:string) {
    this.open.emit(url) ;
  }

  /**
   * Execute a search with the required search expression values.
   * @param expression the fields and values required to perform the search.
   */
  public search(query:DataSourceQuery) {
    this.resultChildren.forEach( c => c.search(query)) ;
  }

  /**
   * Clear the search results.
   */
  public reset() {
    this.resultChildren.forEach( c => c.reset()) ;
  }

  /**
   * Refresh the search results at the current page.
   */
  public refresh() {  
    this.resultChildren.forEach( c => c.refresh()) ;  
  }
}
